import React, { useContext } from "react";
import { Alert, Spin } from "antd";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import { getDebugMode } from "../helpers/constants";

/**
 * Legacy marketing route. Bid comparison UI lived on the old repairs flow;
 * use Contractor Bids (/bids) instead.
 */
const BidComparisonScreenshotPage = () => {
  const { user } = useContext(AuthContext);

  if (!user?.uid) {
    return (
      <div style={{ padding: 64, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!getDebugMode()) {
    return (
      <div style={{ maxWidth: 560, margin: "48px auto", padding: 24 }}>
        <Alert
          type="info"
          showIcon
          message="Bid comparison preview"
          description={
            <>
              This preview path is retired. Open{" "}
              <Link to="/bids">Contractor Bids</Link> to review vendor quotes.
              For other debug demos, add <code>?debug=true</code> or{" "}
              <code>?debug</code> to the URL as elsewhere in the app.
            </>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 560, margin: "48px auto", padding: 24 }}>
      <Alert
        type="info"
        showIcon
        message="Bid comparison preview (debug)"
        description={
          <>
            Use <Link to="/bids">Contractor Bids</Link> for the live bidding
            workspace.
          </>
        }
      />
    </div>
  );
};

export default BidComparisonScreenshotPage;
